import React from 'react';
import Lpbgtop from '../images/lp2.jpg';

function LandingPageTopTwo() {
    
    return (
        <div class="max-w-12xl relative mx-auto">
            <img src={Lpbgtop} className="w-full" style={{ height: 'auto' }} alt="" />
        </div>
    );
}

export default LandingPageTopTwo;
